import { Anchor } from '@components/Anchor';
import { DataTable } from '@components/Table/DataTable';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IModalWindow } from '@hooks/useModalWindow';
import { TableContainerProps } from '@material-ui/core';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import IFatura from '@model/Fatura';
import React from 'react';

export type FaturaAbertaTableProps = {
    isLoading: boolean,
    pagamentoData: IData<IFatura>
    registrarPagamentoModal: IModalWindow
    tableContainerProps?: TableContainerProps

}

export function FaturaAbertaTable ({ isLoading, pagamentoData, registrarPagamentoModal, tableContainerProps }: FaturaAbertaTableProps) {
    const formatter = useFormatter();

    return (
        <DataTable 
            isLoading={isLoading} 
            itemCount={pagamentoData.itemsCount}
            tableContainerProps={tableContainerProps}
        >
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Cliente</TableHeaderCell>
                    <TableHeaderCell>Empresa</TableHeaderCell>
                    <TableHeaderCell>Vencimento</TableHeaderCell>
                    <TableHeaderCell>Valor</TableHeaderCell>
                    <TableHeaderCell>Saldo</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
            {
                pagamentoData.items.map((fatura, index) => {
                    return (
                        <TableRow key={index}>
                            <TableKeyCell><Anchor onClick={pagamentoData.handleRowFocused(fatura, registrarPagamentoModal.open)}>{fatura.faturaId}</Anchor></TableKeyCell>
                            <TableCell>{fatura.clienteNome}</TableCell>
                            <TableCell>{fatura.empresaNome}</TableCell>
                            <TableCell>{formatter.toDate(fatura.dataVencimento)}</TableCell>
                            <TableCell>{formatter.toFloat(fatura.valorTotal)}</TableCell>
                            <TableCell>{formatter.toFloat(fatura.saldo)}</TableCell>
                        </TableRow>
                    )
                })
            }
            </TableBody>
        </DataTable>
     )
}